import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeBraceRight extends Shape {
    needFill = false;
    fillStyleEnabled = false;
    borderStyleEnabled = false;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 18) / 20 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + (width * 2) / 20 + (width * 18) / 20 / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        const r = width / 150;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.arcTo(x + width / 20, y + (height * 1) / 20, x + width / 20, y + height / 2, r);
        canv.ctx.lineTo(x + width / 20, y + (height * 9) / 20);
        canv.ctx.lineTo(x + (width * 2) / 20, y + (height * 10) / 20);
        canv.ctx.lineTo(x + width / 20, y + (height * 11) / 20);
        canv.ctx.lineTo(x + width / 20, y + (height * 19) / 20);
        canv.ctx.arcTo(x + width / 20, y + (height * 19) / 20, x, y + height, r);
        canv.ctx.lineTo(x, y + height);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 11 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path stroke="${stroke}" d="M0.000266433 26H1.13663C2.3422 26 3.49833 25.5211 4.35072 24.6686C5.20322 23.8162 5.68208 22.6601 5.68208 21.4545V18.0455C5.68208 17.1414 6.04129 16.2742 6.68061 15.6349C7.31991 14.9956 8.18703 14.6364 9.09118 14.6364C9.39256 14.6364 9.6816 14.5166 9.89471 14.3035C10.1078 14.0905 10.2275 13.8014 10.2275 13.5C10.2275 13.1986 10.1078 12.9095 9.89471 12.6965C9.6816 12.4834 9.39256 12.3636 9.09118 12.3636C8.18703 12.3636 7.31991 12.0044 6.68061 11.3651C6.04129 10.7258 5.68208 9.85869 5.68208 8.95455V5.54545C5.68208 4.33992 5.20322 3.18377 4.35072 2.33133C3.49833 1.4789 2.3422 1 1.13663 1H0.000266433"/>
            </svg>
        `;
    }
}
